import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/work/WorkClient.tsx");
